module.exports = __webpack_public_path__ + "media/images/connect_dots-27decdacf5261d0489020a74e303f9c7.png";